module.exports = __webpack_public_path__ + "img/2.8ab24f18.png";